var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 11.88 16 23.76 16 36 C10.72 36 5.44 36 0 36 C0 24.12 0 12.24 0 0 Z M6 6 C6 13.92 6 21.84 6 30 C7.32 30 8.64 30 10 30 C10 22.08 10 14.16 10 6 C8.68 6 7.36 6 6 6 Z ",
    fill: "#FFFFFF",
    transform: "translate(42,22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 11.88 16 23.76 16 36 C10.72 36 5.44 36 0 36 C0 24.12 0 12.24 0 0 Z M6 6 C6 13.92 6 21.84 6 30 C7.32 30 8.64 30 10 30 C10 22.08 10 14.16 10 6 C8.68 6 7.36 6 6 6 Z ",
    fill: "#FFFFFF",
    transform: "translate(22,22)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.4cbed4c4008c450af2d4c273c49b116e.svg";
export { ForwardRef as ReactComponent };